<div class="modal-header">
    <h4 class="modal-title">Personel {{data.id == null ? 'Oluştur' : 'Düzenle'}}</h4>
</div>
<div class="modal-body">
    <form [formGroup]="personForm">
        <div class="col-12">
            <label for="title">İsim</label>
            <div class="form-group">
                <div class="input-group">
                    <input type="text" class="form-control" id="name" formControlName="name" maxlength="30" />
                </div>
                <div *ngIf="personForm.get('name').invalid && personForm.get('name').touched" class="text-danger">
                    İsim zorunludur.
                </div>
            </div>
        </div>
        <div class="col-12">
            <label for="description">Soyisim</label>
            <div class="form-group">
                <div class="input-group">
                    <input type="text" class="form-control" id="lastName" formControlName="lastName" maxlength="50" />
                </div>
                <div *ngIf="personForm.get('lastName').invalid && personForm.get('lastName').touched"
                    class="text-danger">
                    Soyisim zorunludur.
                </div>
            </div>
        </div>
        <div class="col-12">
            <label for="description">Görev</label>
            <div class="form-group">
                <div class="input-group">
                    <input type="text" class="form-control" id="mission" formControlName="mission" maxlength="50" />
                </div>
                <div *ngIf="personForm.get('mission').invalid && personForm.get('mission').touched" class="text-danger">
                    Görev zorunludur.
                </div>
            </div>
        </div>

        <div class="col-12">
            <label for="description">Email</label>
            <div class="form-group">
                <div class="input-group">
                    <input type="email" class="form-control" id="mail" formControlName="mail" />
                </div>
            </div>
        </div>

        <div class="col-12">
            <label for="description">Tel No</label>
            <div class="form-group">
                <div class="input-group">
                    <input type="text" class="form-control" id="phoneNumber" formControlName="phoneNumber"
                        mask="(000) 000 00 00" />
                </div>

            </div>
        </div>

        <div class="col-12">
            <label for="description">Adres</label>
            <div class="form-group">
                <div class="input-group">
                    <textarea class="form-control" id="address" formControlName="address" maxlength="200"></textarea>
                </div>
            </div>
        </div>

        <div class="col-12" *ngIf="data.companyId == null">
            <label for="description">Firma</label>
            <div class="form-group">
                <ng-select [items]="companies" bindLabel="companyName" bindValue="id" formControlName="companyId">
                </ng-select>
                <div *ngIf="personForm.get('companyId').invalid && personForm.get('companyId').touched"
                    class="text-danger">
                    Şirket seçmeniz gerekmektedir.
                </div>
            </div>

        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" [disabled]="personForm.invalid" (click)="save()"
        *ngIf="data.id == null ? authService.isEndpointStatus('POST.Writing.CreatePerson') : authService.isEndpointStatus('PUT.Updateing.UpdatePerson')">
        {{ data.id == null ? 'Kaydet' : 'Güncelle' }}
    </button> <button type="button" class="btn btn-danger" (click)="closeModal()">İptal</button>
</div>